var map = {
	"./template.betprofessor": 1150,
	"./template.betprofessor.tsx": 1150,
	"./template.betroyale": 1151,
	"./template.betroyale.tsx": 1151,
	"./template.default": 661,
	"./template.default.tsx": 661,
	"./template.fiestabet": 1152,
	"./template.fiestabet.tsx": 1152,
	"./template.questbet": 1153,
	"./template.questbet.tsx": 1153,
	"./template.ts": 973,
	"./template.vikingbet": 1154,
	"./template.vikingbet.tsx": 1154,
	"./template.volcanobet": 1155,
	"./template.volcanobet.tsx": 1155,
	"./template.wellbet": 1156,
	"./template.wellbet.tsx": 1156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2435;